module.exports = __webpack_public_path__ + "img/icon.f894ffdb.png";